import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Constant } from "../constant";

@Injectable({
    providedIn: 'root'
})
export class RappiService {

    constructor(
        private readonly constant: Constant,
        private readonly http: HttpClient
    ) {}

    public generateCheckuot(id: number) {
        return this.http.post(`${this.constant.api}rappi/checkout`, {
            id
        });
    }
}